import { observer } from 'mobx-react';
import { T } from '../../../../../../Translations';

export interface Props {
  productLicenseTitle: string;
}

function NoActivations({ productLicenseTitle }: Props) {
  return (
    <div className="bg-yellow-50 border-1 border-yellow-400 rounded">
      <p className="text-sm p-3">
        <T
          kind="The {{name}} license associated with this collection has no activations remaining..."
          name={productLicenseTitle}
        />
      </p>
    </div>
  );
}

export default observer(NoActivations);
